import React, { Component, createRef } from "react";
import Modal from "react-bootstrap/Modal";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import { createTheme, ThemeProvider, styled } from "@mui/material/styles";
import sweetAlert, {
    sweetStatusAlert,
} from "../../../../../components/common/SweetAlert";
import { Form } from "react-bootstrap";
import Button from "@mui/material/Button";
import { StudentService } from "../../../../../service/manage/registration/reg_b.service";
import { GenderService } from "../../../../../service/settings/manage/gender.service.js";
import { StatusService } from "../../../../../service/settings/manage/status.service.js";
import { DesignationService } from "../../../../../service/settings/manage/designation.service.js";
import { NonAcademicService } from "../../../../../service/manage/registration/reg_b_staff.service";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import SimpleReactValidator from "simple-react-validator";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import './courselist.css';

const lightTheme = createTheme({ palette: { mode: "light" } });

const Item = styled(Paper)(({ theme }) => ({
    ...theme.typography.body2,
    textAlign: "center",
    color: theme.palette.text.secondary,
    lineHeight: "40px",
    padding: theme.spacing(2), // Add padding
    marginBottom: theme.spacing(1),
    marginRight: theme.spacing(3),
}));

class BlockLetterInput extends Component {
    constructor(props) {
        super(props);
        this.textRefs = Array.from({ length: this.props.values.length }, () =>
            createRef()
        );
    }

    handleChange = (e, index) => {
        const { values, setValues } = this.props;
        const newValues = [...values];
        newValues[index] = e.target.value.toUpperCase().slice(-1);
        setValues(newValues);

        if (index < this.textRefs.length - 1 && newValues[index]) {
            this.textRefs[index + 1].current.focus();
        }
    };

    handleKeyDown = (e, index) => {
        if (e.key === "Backspace" && index > 0 && !this.props.values[index]) {
            const { values, setValues } = this.props;
            const newValues = [...values];
            newValues[index - 1] = "";
            setValues(newValues);
            this.textRefs[index - 1].current.focus();
        }
    };

    render() {
        const { values, label, refIndex, validationMessage, disbaleAllApplicatInputs } = this.props;
        const lines = [];
        for (let i = 0; i < values.length; i += 20) {
            lines.push(values.slice(i, i + 20));
        }

        return (
            <Box sx={{ p: 2 }}>
                <Grid container alignItems="center" spacing={0.7}>
                    <Grid item xs={2}>
                        <Item
                            elevation={0}
                            sx={{
                                fontWeight: "bold",
                                height: "100%",
                                backgroundColor: "#E0E8ED",
                            }}
                        >
                            {label}
                        </Item>
                    </Grid>
                    <Grid item xs={10}>
                        {lines.map((line, lineIndex) => (
                            <Box
                                key={lineIndex}
                                sx={{
                                    borderRadius: 0,
                                    display: "flex",
                                    gap: 0.2,
                                    marginBottom: 0.5,
                                    height: "100%",
                                    flexDirection: "column", // Adjusted to have validation message below the blocks
                                }}
                            >
                                <Box sx={{ display: "flex", gap: 0.2 }}>
                                    {line.map((value, index) => (
                                        <TextField
                                            key={index + lineIndex * 20}
                                            value={value}
                                            onChange={(e) =>
                                                this.handleChange(e, index + lineIndex * 20)
                                            }
                                            onKeyDown={(e) =>
                                                this.handleKeyDown(e, index + lineIndex * 20)
                                            }
                                            inputRef={
                                                index + lineIndex * 20 === refIndex
                                                    ? this.props.forwardedRef
                                                    : this.textRefs[index + lineIndex * 20]
                                            }
                                            inputProps={{
                                                maxLength: 1,
                                                style: {
                                                    borderRadius: 0,
                                                    textTransform: "uppercase",
                                                    width: "4.8ch",
                                                    height: "5.5ch",
                                                    textAlign: "center",
                                                    backgroundColor: "#E0E8ED",
                                                    padding: "0px",
                                                },
                                            }}
                                            disabled={disbaleAllApplicatInputs}
                                            sx={{
                                                borderRadius: 0,
                                                "& .MuiOutlinedInput-root": {
                                                    borderRadius: 0, // Remove rounded corners
                                                },
                                            }}
                                        />
                                    ))}
                                </Box>
                                {lineIndex === lines.length - 1 && (
                                    <Typography
                                        variant="body2"
                                        sx={{ color: "red", textAlign: "left", mt: 0.5 }}
                                    >
                                        {validationMessage}
                                    </Typography>
                                )}
                            </Box>
                        ))}
                    </Grid>
                </Grid>
            </Box>
        );
    }
}

export default class RegBUpdateStaffModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            isModified: false,
            showInsertModal: false,
            full_name: Array(60).fill(""),
            first_name: Array(20).fill(""),
            last_name: Array(20).fill(""),
            user_code: "Generating...",
            gender: "",
            gender_id: "",
            designation_id: "",
            status_id: "",
            designations: [],
            statuses: [],
            genders: [],
            name_as_nic: "",
            dob: "",
            nationality: "",
            nic: "",
            mobile: "",
            email: "",
            home: "",
            office: "",
            address_for_correspondence: "",
            permanent_address: "",

            ol: 0,
            al: 0,
            english_ability: 0,
            min_entry_qualification: "",
            designation: "",
            status: 0,

            olQualifications: [],
            alQualifications: [],
            selectedShedule: '',
            selectedMedium: '',



            disbaleAllApplicatInputs: true,
            disableApplicantAcknowledge: true,
            disableApprove: true,

            formIsValid: false,
            user_approval: 0,
            info_approval: 0,
            officeSectionAvailability: false,
            enrollments: [],
            checked_enrollments: [],
        };

        this.createValidationsInstance();

        this.formInitialState = {
            isModified: false,
            full_name: Array(60).fill(""),
            first_name: Array(20).fill(""),
            last_name: Array(20).fill(""),
            user_code: "Generating...",
            gender: "",
            name_as_nic: "",
            dob: null,
            nationality: "",
            nic: "",
            mobile: "",
            email: "",
            home: "",
            office: "",
            address_for_correspondence: "",
            permanent_address: "",
            note: "",
            qualification: "",
            institution: "",
            academic_year: "",
            other_details: "",
            other_qualification: "",
            designation: "",
            status: 0,
            olQualifications: [],
            alQualifications: [],
            selectedShedule: '',
            selectedMedium: '',
            formIsValid: false,
            checked_enrollments: [],
            enrollments: this.props?.enrollments || [],
            hasFullPrivilege: false,

        };
    }

    createValidationsInstance() {
        this.validator = new SimpleReactValidator({
            validators: {
                address: {
                    message: "The :attribute must be a valid address",
                    rule: (val, params, validator) => {
                        return (
                            validator.helpers.testRegex(val, /^[a-zA-Z-/:0-9,\s]+$/i) &&
                            params.indexOf(val) === -1
                        );
                    },
                    messageReplace: (message, params) =>
                        message.replace(":values", this.helpers.toSentence(params)), // optional
                },
                dateBefore: {
                    message: "The :attribute must be before current date",
                    rule: (val, params, validator) => {
                        const selectedDate = new Date(val);
                        const currentDate = new Date();
                        return selectedDate < currentDate;
                    },
                    messageReplace: (message, params) =>
                        message.replace(":values", this.helpers.toSentence(params)), // optional
                    required: true,
                },
                phone_number: {
                    message: "The :attribute must be a valid phone number",
                    rule: (val, params, validator) => {
                        const isTenDigitsStartingWithZero =
                            val.length === 10 && val.startsWith("0");
                        const isNineDigits = val.length === 9 && !val.startsWith("0");
                        return isTenDigitsStartingWithZero || isNineDigits;
                    },
                    messageReplace: (message, params) =>
                        message.replace(":values", this.helpers.toSentence(params)), // optional
                    required: true,
                },
            },
        });
        this.updateValidator = new SimpleReactValidator();
    }

    getGenderDropdownValues = () => {
        this.setState({ isLoading: true });
        GenderService.getAllGenders().then((res) => {
            this.setState({ genders: res.data });
        });
        this.setState({ isLoading: false });
    };

    getDesignationDropdownValues = () => {
        this.setState({ isLoading: true });
        DesignationService.getAllDesignations().then((response) => {
            if (response.success) {
                this.setState({ designations: response.data });
            }
        });
        this.setState({ isLoading: false });
    };

    getUserStatusDropdownValues = () => {
        this.setState({ isLoading: true });
        StatusService.getAllStatusesForDropdown().then((response) => {
            if (response.success) {
                this.setState({ statuses: response.data });
            }
        });
        this.setState({ isLoading: false });
    };

    componentDidMount = () => {
        this.setState({ isLoading: true });
        this.getDesignationDropdownValues();
        this.getGenderDropdownValues();
        this.getUserStatusDropdownValues();
        const studentItem = this.props.updateStudentItem;
        const olQualifications = this.props.olQualifications;
        const alQualifications = this.props.alQualifications;
        const otherQualifications = this.props.otherQualifications;
        let privilege_edit = !!this.props.state.privilege_edit;
        let privilege_add = !!this.props.state.privilege_add;
        let privilege_delete = !!this.props.state.privilege_delete;
        this.setState({ hasFullPrivilege: this.checkFullPrivilege() });
        if (studentItem) {
            this.setState({
                first_name: studentItem.first_name ? studentItem.first_name : "",
                last_name: studentItem.last_name ? studentItem.last_name : "",
                disbaleAllApplicatInputs: !!studentItem.info_approval || (!privilege_edit && !privilege_add),
                disableApplicantAcknowledge: !privilege_edit || !this.validator.allValid(),
                disableApprove: !privilege_delete,
                officeSectionAvailability: privilege_delete || privilege_add,
                user_code: studentItem.user_code ? studentItem.user_code : "",
                name_as_nic: studentItem.name_as_nic
                    ? studentItem.name_as_nic
                    : "",
                gender: studentItem.gender ? studentItem.gender : "",
                gender_id: studentItem.gender_id ? studentItem.gender_id : "",
                designation_id: studentItem.designation_id ? studentItem.designation_id : "",
                status_id: studentItem.user_status_id ? studentItem.user_status_id : "",
                dob: studentItem.dob ? studentItem.dob : "",
                nationality: studentItem.nationality ? studentItem.nationality : "",
                nic: studentItem.nic ? studentItem.nic : "",
                mobile: studentItem.mobile ? studentItem.mobile : "",
                note: studentItem.note ? studentItem.note : "",
                email: studentItem.email ? studentItem.email : "",
                home: studentItem.home ? studentItem.home : "",
                office: studentItem.office ? studentItem.office : "",
                address: studentItem.address
                    ? studentItem.address
                    : "",
                permanent_address: studentItem.permanent_address
                    ? studentItem.permanent_address
                    : "",
                ol_year: studentItem.ol_year ? studentItem.ol_year : "",
                ol_school: studentItem.ol_school ? studentItem.ol_school : "",
                al_year: studentItem.al_year ? studentItem.al_year : "",
                al_school: studentItem.al_school ? studentItem.al_school : "",

                work_experience: studentItem.work_experience
                    ? studentItem.work_experience
                    : "",

                ol: studentItem.ol ? studentItem.ol : 0,
                al: studentItem.al ? studentItem.al : 0,
                english_ability: studentItem.english_ability
                    ? studentItem.english_ability
                    : 0,
                min_entry_qualification: studentItem.min_entry_qualification
                    ? studentItem.min_entry_qualification
                    : "",
                designation: studentItem.designation
                    ? studentItem.designation
                    : "",
                status: studentItem.status ? studentItem.status : 0,
                overseas_nic_passport: studentItem.overseas_nic_passport
                    ? studentItem.overseas_nic_passport
                    : 0,
                overseas_educational_doc: studentItem.overseas_educational_doc
                    ? studentItem.overseas_educational_doc
                    : 0,
                overseas_color_photo: studentItem.overseas_color_photo
                    ? studentItem.overseas_color_photo
                    : 0,
                overseas_work_experience_doc: studentItem.overseas_work_experience_doc
                    ? studentItem.overseas_work_experience_doc
                    : 0,
                selectedShedule: studentItem.shedule ? studentItem.shedule : "",
                selectedMedium: studentItem.medium ? studentItem.medium : "",
                checked_enrollments: studentItem.enrolled_nodes ? studentItem.enrolled_nodes : [],
                user_approval: studentItem.user_approval ? studentItem.user_approval : 0,
                info_approval: studentItem.info_approval ? studentItem.info_approval : 0,
            }, () => {
                this.updateFormValidity()
            });
        }
        this.setState({ isLoading: false });
    }

    padArray = (array, length) => {
        while (array.length < length) {
            array.push("");
        }
        return array;
    };

    handleMedium = (event) => {
        this.setState({ selectedMedium: event.target.value }, () => {
            this.updateFormValidity()
        });
    };

    checkFullPrivilege() {
        const { privilege_edit, privilege_add, privilege_delete } = this.props.state;
        return privilege_edit && privilege_add && privilege_delete;
    }

    handleShedule = (event) => {
        this.setState({ selectedShedule: event.target.value }, () => {
            this.updateFormValidity()
        });
    };

    getNewStudentId = async () => {
        const response = await StudentService.getRegStudentId();

        if (response.success) {
            const { new_id } = response.data;
            if (new_id) {
                this.setState({ user_code: new_id });
            }
        } else {
            this.setState({ user_code: "Student Id Error" });
        }
    };

    toggleAddStudentModal = () => {
        this.setState(
            (prevState) => ({
                showInsertModal: !prevState.showInsertModal,
                first_name: "",
                last_name: "",
                nic: "",
                dob: "",
                email: "",
                phone_number: "",
                gender_id: "",
                status_id: "",
                created_on: "",
                created_by: "",
                studentAddresses: [],
                grade: null,
                school: "",
                checked_enrollments: [],
                enrollments: [],
            }),
            () => {
                // State has changed, perform your logic here based on the state change
                if (this.state.showInsertModal) {
                    this.getAllGrades();
                }
            }
        );
    };

    handleSweetAlert = (toggleFunction, modalVisibility) => {
        if (this.state.isModified) {
            sweetAlert().then((response) => {
                this.setState(this.formInitialState);
                this.setState(() => ({
                    [modalVisibility]: response,
                    isModified: false,
                }));
                this.toggleAddStudentModal();
                toggleFunction();
            });
        } else {
            this.setState(this.formInitialState);
            this.toggleAddStudentModal();
            toggleFunction();
        }
    };

    updateFormValidity = () => {
        const formIsValid = this.validator.allValid();
        if (formIsValid) {
            this.setState({
                disableApplicantAcknowledge: !this.props.state.privilege_edit || !formIsValid
            });
        }
        this.setState({ formIsValid });
    };

    handleCheckboxChange = (mid) => {
        if (!this.state.hasFullPrivilege) return;

        this.setState((prevState) => {
            const { checked_enrollments } = prevState;
            if (checked_enrollments.includes(mid)) {
                return {
                    checked_enrollments: checked_enrollments.filter((id) => id !== mid),
                };
            } else {
                return {
                    checked_enrollments: [...checked_enrollments, mid],
                };
            }
        });
    };

    handleChange = (event) => {
        const { name, type, checked, value } = event.target;
        const newValue = type === "checkbox" ? (checked ? 1 : 0) : value;
        this.setState({ [name]: newValue, isModified: true }, () => {
            this.updateFormValidity()
        });
    };

    handleBlockInputChangeFullName = (newValues) => {
        this.setState({ full_name: newValues }, () => {
            this.updateFormValidity()
        });
        const fullNameString = this.convertArrayToString(newValues);
    };

    handleBlockInputChangeFirstName = (newValues) => {
        this.setState({ first_name: newValues }, () => {
            this.updateFormValidity()
        });
        const firstNameString = this.convertArrayToString(newValues);
    };

    handleBlockInputChangeLastName = (newValues) => {
        this.setState({ last_name: newValues }, () => {
            this.updateFormValidity()
        });
        const lastNameString = this.convertArrayToString(newValues);
    };

    convertArrayToString = (arr) => {
        if (Array.isArray(arr)) {
            return arr.join("").trim();
        }
        return "";
    };

    handleOlSubjectChange = (event, index) => {
        const { name, value } = event.target;

        this.setState((prevState) => {
            const ol_subjects = [...prevState.ol_subjects];
            ol_subjects[index][name] = value;
            return { ol_subjects };
        }, () => {
            this.updateFormValidity()
        });
    };

    handleAlSubjectChange = (event, index) => {
        const { name, value } = event.target;

        this.setState((prevState) => {
            const al_subjects = [...prevState.al_subjects];
            al_subjects[index][name] = value;
            return { al_subjects };
        }, () => {
            this.updateFormValidity()
        });
    };

    handleUpdateSubmit = async (event) => {
        if (!this.validator.allValid()) {
            this.validator.showMessages();
            this.forceUpdate();
        } else {
            this.setState({ isLoading: true });
            try {
                const {
                    first_name,
                    last_name,
                    user_code,
                    designation_id,
                    gender_id,
                    status_id,
                    gender,
                    nic,
                    mobile,
                    note,
                    email,
                    address,
                    designation,
                    status,
                } = this.state;

                const updateStaffMember = {
                    first_name: first_name,
                    last_name: last_name,
                    gender_id: gender_id,
                    nic: nic,
                    mobile: mobile,
                    note: note,
                    email: email,
                    address: address,
                    designation_id: designation_id,
                    status: status_id,
                };

                const staffResponse = await NonAcademicService.update(
                    updateStaffMember,
                    this.props.updateStudentItem?.user_id
                );

                if (staffResponse.success) {
                    this.setState({ isLoading: false });
                    sweetStatusAlert(
                        "Success!",
                        "Staff member updated successfully!",
                        "success"
                    );
                    this.props.toggleAddStudentModal();
                    this.setState(this.formInitialState);
                } else {
                    this.setState({ isLoading: false });
                    sweetStatusAlert("Failed!", "Failed to update staff member", "error");
                }
            } catch (e) {
                this.setState({ isLoading: false });
                sweetStatusAlert("Failed!", "Failed to update staff member", "error");
            }

        }
    };

    componentDidUpdate(prevProps) {
        if (prevProps.enrollments !== this.props.enrollments) {
            this.setState({ enrollments: this.props.enrollments });
        }
    }

    render() {
        const {
            isLoading,
            designations,
            statuses,
            genders,
            gender_id,
            designation_id,
            status_id,
            full_name,
            first_name,
            last_name,
            user_code,
            name_as_nic,
            gender,
            dob,
            nationality,
            nic,
            mobile,
            email,
            note,
            home,
            office,
            address,
            permanent_address,
            ol_year,
            ol_school,
            al_year,
            al_school,

            ol_subject1,
            ol_grade1,
            ol_subject2,
            ol_grade2,
            ol_subject3,
            ol_grade3,
            ol_subject4,
            ol_grade4,
            ol_subject5,
            ol_grade5,
            ol_subject6,
            ol_grade6,
            ol_subject7,
            ol_grade7,
            ol_subject8,
            ol_grade8,
            ol_subject9,
            ol_grade9,
            ol_subject10,
            ol_grade10,

            al_subject1,
            al_grade1,
            al_subject2,
            al_grade2,
            al_subject3,
            al_grade3,
            al_subject4,
            al_grade4,
            al_subject5,
            al_grade5,

            qualification,
            institution,
            academic_year,
            other_details,
            other_qualification,

            work_experience,

            ol,
            al,
            english_ability,
            min_entry_qualification,
            designation,
            status,
            overseas_nic_passport,
            overseas_educational_doc,
            overseas_color_photo,
            overseas_work_experience_doc,

            olState,
            alState,
            disbaleAllApplicatInputs,
            disableApplicantAcknowledge,
            disableApprove,
            user_approval,
            info_approval,
            enrollments,
            checked_enrollments,
            hasFullPrivilege
        } = this.state;

        const {
            isAddStudentModalOpen,
            toggleAddStudentModal,
            updateStudentItem,
            isStudent,
            isAdmin,
            olQualifications,
            alQualifications,
            otherQualifications,

        } = this.props;

        return (
            <>
                <Modal
                    size="xl"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                    show={isAddStudentModalOpen}
                    onHide={() =>
                        this.handleSweetAlert(toggleAddStudentModal, "showInsertModal")
                    }
                >
                    <Modal.Header closeButton>
                        <Modal.Title centered={true}>Asian Elite Hotel School</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        <Backdrop
                            sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
                            open={isLoading}
                        >
                            <CircularProgress color="inherit" />
                        </Backdrop>

                        <Form>
                            <Grid container spacing={5} rowSpacing={5}>
                                {[lightTheme].map((theme, index) => (
                                    <ThemeProvider theme={theme} key={index}>
                                        <Grid item xs={12}>
                                            <Item elevation={8}>
                                                <Grid
                                                    alignItems="center"
                                                    container
                                                    spacing={2}
                                                    sx={{ p: 2 }}
                                                >
                                                    <Grid item xs={12}>
                                                        <Typography
                                                            variant="h6"
                                                            sx={{ fontWeight: "bold" }}
                                                        >
                                                            Non Academic Staff Registration
                                                        </Typography>
                                                    </Grid>
                                                </Grid>
                                            </Item>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Item elevation={8}>
                                                <Grid
                                                    container
                                                    spacing={2}
                                                    alignItems="center"
                                                    sx={{ p: 2 }}
                                                >
                                                    <Grid item xs={12}>
                                                        <Item elevation={0} sx={{ pl: 5, pr: 5 }}>
                                                            <Grid
                                                                container
                                                                spacing={1}
                                                                alignItems="center"
                                                                sx={{ pl: 5, pr: 5 }}
                                                            >
                                                                <Grid item xs={6}>
                                                                    <Item
                                                                        elevation={0}
                                                                        sx={{
                                                                            lineHeight: "20px",
                                                                            padding: "4px 0",
                                                                            fontWeight: "bold",
                                                                            backgroundColor: "#E0E8ED",
                                                                        }}
                                                                    >
                                                                        <TextField
                                                                            onChange={this.handleChange}
                                                                            name="first_name"
                                                                            value={first_name}
                                                                            fullWidth
                                                                            id="outlined-basic"
                                                                            label="First Name"
                                                                            variant="outlined"
                                                                            disabled={disbaleAllApplicatInputs}
                                                                        />
                                                                        <div style={{ textAlign: "left" }}>
                                                                            {this.validator.message(
                                                                                "first_name",
                                                                                first_name,
                                                                                "required|first_name|max:50",
                                                                                {
                                                                                    className: "text-danger",
                                                                                    messages: {
                                                                                        required: "The first name is required.",
                                                                                        max: "First name must be less than 50 characters.",
                                                                                    },
                                                                                }
                                                                            )}
                                                                        </div>
                                                                    </Item>
                                                                </Grid>
                                                                <Grid item xs={6}>
                                                                    <Item
                                                                        elevation={0}
                                                                        sx={{
                                                                            lineHeight: "20px",
                                                                            padding: "4px 0",
                                                                            fontWeight: "bold",
                                                                            backgroundColor: "#E0E8ED",
                                                                        }}
                                                                    >
                                                                        <TextField
                                                                            onChange={this.handleChange}
                                                                            name="last_name"
                                                                            value={last_name}
                                                                            fullWidth
                                                                            id="outlined-basic"
                                                                            label="Last Name"
                                                                            variant="outlined"
                                                                            disabled={disbaleAllApplicatInputs}
                                                                        />
                                                                        <div style={{ textAlign: "left" }}>
                                                                            {this.validator.message(
                                                                                "last_name",
                                                                                last_name,
                                                                                "required|last_name|max:50",
                                                                                {
                                                                                    className: "text-danger",
                                                                                    messages: {
                                                                                        required: "The last name is required.",
                                                                                        max: "Last name must be less than 50 characters.",
                                                                                    },
                                                                                }
                                                                            )}
                                                                        </div>
                                                                    </Item>
                                                                </Grid>
                                                                <Grid item xs={6}>
                                                                    <Item
                                                                        elevation={0}
                                                                        sx={{
                                                                            lineHeight: "20px",
                                                                            padding: "4px 0",
                                                                            fontWeight: "bold",
                                                                            backgroundColor: "#E0E8ED",
                                                                        }}
                                                                    >
                                                                        <TextField
                                                                            onChange={this.handleChange}
                                                                            name="mobile"
                                                                            value={mobile}
                                                                            fullWidth
                                                                            id="outlined-basic"
                                                                            label="Mobile number"
                                                                            variant="outlined"
                                                                            disabled={disbaleAllApplicatInputs}
                                                                        />
                                                                        <div style={{ textAlign: "left" }}>
                                                                            {this.validator.message(
                                                                                "mobile",
                                                                                mobile,
                                                                                "required|numeric|min:9|max:12",
                                                                                {
                                                                                    className: "text-danger",
                                                                                    messages: {
                                                                                        required:
                                                                                            "The mobile number is required.",
                                                                                        numeric:
                                                                                            "The mobile number must contain only digits.",
                                                                                        min: "The mobile number must be at least 9 digits.",
                                                                                        max: "The mobile number cannot exceed 12 digits.",
                                                                                    },
                                                                                }
                                                                            )}
                                                                        </div>
                                                                    </Item>
                                                                </Grid>
                                                                <Grid item xs={6}>
                                                                    <Item
                                                                        elevation={0}
                                                                        sx={{
                                                                            lineHeight: "20px",
                                                                            padding: "4px 0",
                                                                            fontWeight: "bold",
                                                                            backgroundColor: "#E0E8ED",
                                                                        }}
                                                                    >
                                                                        <TextField
                                                                            onChange={this.handleChange}
                                                                            name="email"
                                                                            value={email}
                                                                            disabled={true} 
                                                                            fullWidth
                                                                            id="outlined-basic"
                                                                            label="Email"
                                                                            variant="outlined"
                                                                        />
                                                                        <div style={{ textAlign: "left" }}>
                                                                            {this.validator.message(
                                                                                "email",
                                                                                email,
                                                                                "required|email|max:150",
                                                                                {
                                                                                    className: "text-danger",
                                                                                    messages: {
                                                                                        required: "The email is required.",
                                                                                        max: "Email must be less than 150 characters.",
                                                                                    },
                                                                                }
                                                                            )}
                                                                        </div>
                                                                    </Item>
                                                                </Grid>
                                                                <Grid item xs={6}>
                                                                    <Item
                                                                        elevation={0}
                                                                        sx={{
                                                                            lineHeight: "20px",
                                                                            padding: "4px 0",
                                                                            fontWeight: "bold",
                                                                            backgroundColor: "#E0E8ED",
                                                                        }}
                                                                    >
                                                                        <TextField
                                                                            value={nic}
                                                                            onChange={this.handleChange}
                                                                            name="nic"
                                                                            id="outlined-basic"
                                                                            label="NIC / Passport No"
                                                                            variant="outlined"
                                                                            disabled={disbaleAllApplicatInputs}
                                                                            fullWidth
                                                                            sx={{ bgcolor: "#E0E8ED" }} // Consistent background color
                                                                        />
                                                                        <div style={{ textAlign: "left" }}>
                                                                            {this.validator.message(
                                                                                "nic",
                                                                                nic,
                                                                                "required|max:12",
                                                                                {
                                                                                    className: "text-danger",
                                                                                    messages: {
                                                                                        required: "The student NIC is required.",
                                                                                        max: "The student NIC must be no longer than 12 characters.",
                                                                                    },
                                                                                }
                                                                            )}
                                                                        </div>
                                                                    </Item>
                                                                </Grid>
                                                                <Grid item xs={6}>
                                                                    <Item
                                                                        elevation={0}
                                                                        sx={{
                                                                            lineHeight: "20px",
                                                                            padding: "4px 0",
                                                                            fontWeight: "bold",
                                                                            backgroundColor: "#E0E8ED",
                                                                        }}
                                                                    >
                                                                        <TextField
                                                                            onChange={this.handleChange}
                                                                            name="address"
                                                                            value={address}
                                                                            fullWidth
                                                                            id="outlined-basic"
                                                                            label="Address"
                                                                            variant="outlined"
                                                                            disabled={disbaleAllApplicatInputs}
                                                                        />
                                                                        <div style={{ textAlign: "left" }}>
                                                                            {this.validator.message(
                                                                                "address",
                                                                                address,
                                                                                "required|max:200",
                                                                                {
                                                                                    className: "text-danger",
                                                                                    messages: {
                                                                                        required: "Address is required.",
                                                                                        max: "Address must be less than 200 characters.",
                                                                                    },
                                                                                }
                                                                            )}
                                                                        </div>
                                                                    </Item>
                                                                </Grid>
                                                            </Grid>
                                                        </Item>
                                                        <Row>
                                                            <Col xs={12} md={4} className="pl-0">
                                                                <Form.Group controlId="exampleForm.ControlInput1">
                                                                    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                                                        <Item
                                                                            className="member_status_item"
                                                                            elevation={0}
                                                                            sx={{
                                                                                lineHeight: "20px",
                                                                                fontWeight: "bold",
                                                                                width: "30%",
                                                                            }}
                                                                        >
                                                                            Gender
                                                                        </Item>
                                                                        <Form.Select
                                                                            aria-label="Default select example"
                                                                            name="gender_id"
                                                                            value={gender_id}
                                                                            onChange={this.handleChange}
                                                                            disabled={disbaleAllApplicatInputs}
                                                                            style={{ backgroundColor: "#E0E8ED", flex: 1, width: "70%" }}
                                                                        >
                                                                            <option value="" disabled>Select</option>
                                                                            {genders?.map((gender) => (
                                                                                <option key={gender.gender_id} value={gender.gender_id}>
                                                                                    {gender.name}
                                                                                </option>
                                                                            ))}
                                                                        </Form.Select>
                                                                    </div>
                                                                    {this.validator.message("gender_id", gender_id, "required", {
                                                                        className: "text-danger",
                                                                        messages: { required: "The gender is required." },
                                                                    })}
                                                                </Form.Group>
                                                            </Col>
                                                            <Col xs={12} md={4} className="pl-0">
                                                                <Form.Group controlId="exampleForm.ControlInput2">
                                                                    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                                                        <Item
                                                                            className="member_status_item"
                                                                            elevation={0}
                                                                            sx={{
                                                                                lineHeight: "20px",
                                                                                fontWeight: "bold",
                                                                                width: "30%",
                                                                            }}
                                                                        >
                                                                            Designation
                                                                        </Item>
                                                                        <Form.Select
                                                                            aria-label="Default select example"
                                                                            name="designation_id"
                                                                            value={designation_id}
                                                                            onChange={this.handleChange}
                                                                            disabled={disbaleAllApplicatInputs}
                                                                            style={{ backgroundColor: "#E0E8ED", flex: 1, width: "70%" }}
                                                                        >
                                                                            <option value="" disabled>Select</option>
                                                                            {designations?.map((designation) => (
                                                                                <option key={designation.designation_id} value={designation.designation_id}>
                                                                                    {designation.name}
                                                                                </option>
                                                                            ))}
                                                                        </Form.Select>
                                                                    </div>
                                                                    {this.validator.message("designation", designation_id, "required", {
                                                                        className: "text-danger",
                                                                        messages: { required: "The designation is required." },
                                                                    })}
                                                                </Form.Group>
                                                            </Col>
                                                            <Col xs={12} md={4} className="pl-0">
                                                                <Form.Group controlId="exampleForm.ControlInput3">
                                                                    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                                                        <Item
                                                                            className="member_status_item"
                                                                            elevation={0}
                                                                            sx={{
                                                                                lineHeight: "20px",
                                                                                fontWeight: "bold",
                                                                                width: "30%",
                                                                            }}
                                                                        >
                                                                            Status
                                                                        </Item>
                                                                        <Form.Select
                                                                            aria-label="Default select example"
                                                                            name="status_id"
                                                                            value={status_id}
                                                                            onChange={this.handleChange}
                                                                            disabled={disbaleAllApplicatInputs}
                                                                            style={{ backgroundColor: "#E0E8ED", flex: 1, width: "70%" }}
                                                                        >
                                                                            <option value="" disabled>Select</option>
                                                                            {statuses?.map((status) => (
                                                                                <option key={status.status_id} value={status.status_id}>
                                                                                    {status.name}
                                                                                </option>
                                                                            ))}
                                                                        </Form.Select>
                                                                    </div>
                                                                    {this.validator.message("status_id", status_id, "required", {
                                                                        className: "text-danger",
                                                                        messages: { required: "The status is required." },
                                                                    })}
                                                                </Form.Group>
                                                            </Col>
                                                        </Row>
                                                        <Item elevation={0} sx={{ pl: 5, pr: 5 }}>
                                                            <Grid
                                                                container
                                                                spacing={1}
                                                                alignItems="center"
                                                                sx={{ pl: 5, pr: 5 }}
                                                            >
                                                                <Grid item xs={12}>
                                                                    <Item
                                                                        elevation={0}
                                                                        sx={{
                                                                            height: "250px",
                                                                            lineHeight: "20px",
                                                                            padding: "4px 0",
                                                                            fontWeight: "bold",
                                                                            backgroundColor: "#E0E8ED",
                                                                        }}
                                                                    >
                                                                        <TextField
                                                                            value={note}
                                                                            onChange={this.handleChange}
                                                                            name="note"
                                                                            multiline
                                                                            rows={11}
                                                                            fullWidth
                                                                            id="outlined-textarea"
                                                                            label="Note"
                                                                            variant="outlined"
                                                                            disabled={disbaleAllApplicatInputs}
                                                                        />
                                                                    </Item>
                                                                    <div style={{ textAlign: "left" }}>
                                                                    {this.validator.message(
                                                                        "note",
                                                                        note,
                                                                        "max:2000",
                                                                        {
                                                                        className: "text-danger",
                                                                        messages: {
                                                                            max: "Note should not be greater than 2000 characters."
                                                                        },
                                                                        }
                                                                    )}
                                                                    </div>
                                                                </Grid>
                                                            </Grid>
                                                        </Item>
                                                    </Grid>
                                                </Grid>
                                            </Item>
                                        </Grid>
                                        { !disbaleAllApplicatInputs &&
                                        <Grid item xs={12}>
                                            <Item elevation={0}>
                                                <Button
                                                    variant="contained"
                                                    size="large"
                                                    onClick={() => this.handleUpdateSubmit()}
                                                >
                                                    Update
                                                </Button>
                                            </Item>
                                        </Grid>
                                        }
                                    </ThemeProvider>
                                ))}
                            </Grid>
                        </Form>
                    </Modal.Body>
                </Modal>
            </>
        );
    }
}
